import Black from '@/assets/hyperbet/fonts/Roboto-Black.ttf';
import BlackItalic from '@/assets/hyperbet/fonts/Roboto-BlackItalic.ttf';
import Bold from '@/assets/hyperbet/fonts/Roboto-Bold.ttf';
import BoldItalic from '@/assets/hyperbet/fonts/Roboto-BoldItalic.ttf';
import ExtraLight from '@/assets/hyperbet/fonts/Roboto-Thin.ttf';
import ExtraLightItalic from '@/assets/hyperbet/fonts/Roboto-ThinItalic.ttf';
import Light from '@/assets/hyperbet/fonts/Roboto-Light.ttf';
import LightItalic from '@/assets/hyperbet/fonts/Roboto-LightItalic.ttf';
import Regular from '@/assets/hyperbet/fonts/Roboto-Regular.ttf';
import Italic from '@/assets/hyperbet/fonts/Roboto-Italic.ttf';
import SemiBold from '@/assets/hyperbet/fonts/Roboto-Medium.ttf';
import SemiBoldItalic from '@/assets/hyperbet/fonts/Roboto-MediumItalic.ttf';
import StaatlichesRegular from '@/assets/hyperbet/fonts/Staatliches-Regular.ttf';
import KHInterferenceRegular from '@/assets/hyperbet/fonts/KHInterference-Regular.otf';
import KHInterferenceLight from '@/assets/hyperbet/fonts/KHInterference-Light.otf';
import KHInterferenceBold from '@/assets/hyperbet/fonts/KHInterference-Bold.otf';
import OrbitronRegular from '@/assets/hyperbet/fonts/Orbitron-Regular.ttf';
import OrbitronBlack from '@/assets/hyperbet/fonts/Orbitron-Black.ttf';

export const fontFace = `
        @font-face {
          font-family: 'Orbitron';
          font-style: normal;
          font-weight: 900;
          font-display: swap;
          src: url('${OrbitronBlack}') format('opentype');
        }
        @font-face {
          font-family: 'Orbitron';
          font-style: normal;
          font-weight: 400;
          font-display: swap;
          src: url('${OrbitronRegular}') format('opentype');
        }
        @font-face {
          font-family: 'KHInterference';
          font-style: normal;
          font-weight: 400;
          font-display: swap;
          src: url('${KHInterferenceRegular}') format('opentype');
        }
        @font-face {
          font-family: 'KHInterference';
          font-style: normal;
          font-weight: 300;
          font-display: swap;
          src: url('${KHInterferenceLight}') format('opentype');
        }
        @font-face {
          font-family: 'KHInterference';
          font-style: normal;
          font-weight: 700;
          font-display: swap;
          src: url('${KHInterferenceBold}') format('opentype');
        }
        @font-face {
          font-family: 'Staatliches';
          font-style: normal;
          font-weight: 400;
          font-display: swap;
          src: url('${StaatlichesRegular}') format('opentype');
        }
        @font-face {
          font-family: 'roboto';
          font-style: normal;
          font-weight: 100;
          font-display: swap;
          src: url('${ExtraLight}') format('opentype');
        }
        @font-face {
          font-family: 'roboto';
          font-style: italic;
          font-weight: 100;
          font-display: swap;
          src: url('${ExtraLightItalic}') format('opentype');
        }
      
        @font-face {
          font-family: 'roboto';
          font-style: normal;
          font-weight: 300;
          font-display: swap;
          src: url('${Light}') format('opentype');
        }
        @font-face {
          font-family: 'roboto';
          font-style: italic;
          font-weight: 300;
          font-display: swap;
          src: url('${LightItalic}') format('opentype');
        }
      
        @font-face {
          font-family: 'roboto';
          font-style: normal;
          font-weight: 400;
          font-display: swap;
          src: url('${Regular}') format('opentype');
        }
        @font-face {
          font-family: 'roboto';
          font-style: italic;
          font-weight: 400;
          font-display: swap;
          src: url('${Italic}') format('opentype');
        }
      
        @font-face {
          font-family: 'roboto';
          font-style: normal;
          font-weight: 500;
          font-display: swap;
          src: url('${SemiBold}') format('opentype');
        }
        @font-face {
          font-family: 'roboto';
          font-style: italic;
          font-weight: 500;
          font-display: swap;
          src: url('${SemiBoldItalic}') format('opentype');
        }
      
        @font-face {
          font-family: 'roboto';
          font-style: normal;
          font-weight: 700;
          font-display: swap;
          src: url('${Bold}') format('opentype');
        }
        @font-face {
          font-family: 'roboto';
          font-style: italic;
          font-weight: 700;
          font-display: swap;
          src: url('${BoldItalic}') format('opentype');
        }
      
        @font-face {
          font-family: 'roboto';
          font-style: normal;
          font-weight: 900;
          font-display: swap;
          src: url('${Black}') format('opentype');
        }
        @font-face {
          font-family: 'roboto';
          font-style: italic;
          font-weight: 900;
          font-display: swap;
          src: url('${BlackItalic}') format('opentype');
        }
      `;
